import {Injectable} from '@angular/core';
import {TranslateLoader} from "@ngx-translate/core";
import {HttpClient} from "@angular/common/http";
import {catchError, map, Observable, of, retry, tap} from "rxjs";
import {environment} from "../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class CustomTranslateLoader implements TranslateLoader {
  private _translateUrl = `${environment.baseUrl}/api/i18n/translations/`;
  private _cache = new Map<string, any>();

  // Локальные ключи, которых пока нет в бэковом i18n (портфельный модуль).
  // Бэковый перевод перекрывает локальный, если ключ там появится.
  private readonly _local: Record<string, Record<string, string>> = {
    ru: {SIDE_BAR_PORTFOLIOS: 'Портфели'},
    en: {SIDE_BAR_PORTFOLIOS: 'Portfolios'},
  };

  constructor(private _http: HttpClient) {
  }

  private _withLocal(lang: string, data: any): any {
    return {...(this._local[lang] || {}), ...(data || {})};
  }

  getTranslation(lang: string): Observable<any> {
    return this._http.get(this._translateUrl, {
      params: {locale: lang}
    }).pipe(
      retry({count: 2, delay: 300}),
      tap(data => this._cache.set(lang, data)),
      map(response => this._withLocal(lang, response)),
      catchError((err) => {
        const cachedTranslation = this._cache.get(lang);

        if (cachedTranslation) {
          console.warn(`Failed to load translations for ${lang} after retries. Returning CACHED version.`);
          return of(this._withLocal(lang, cachedTranslation));
        }

        console.error(`Failed to load ${lang} and no cache available.`, err);
        return of(this._withLocal(lang, {}));
      }),
    );
  }
}
